import React from 'react';
import {

  PlayersInner,
  PlayerInner,
  PlayerPair,
  ActionButton,
  EmptyPlayer

} from './final.js';

class PlayersPairs extends PlayersInner {

    playerInner = (flag) => {
        return (player, i) => {
            const partner = player._pair === null
                ? <EmptyPlayer inPairGroup />
                : <PlayerPair player={player._pair} flag={''} inPairGroup />;

            return (
                <li className="game__list-pair" key={i}>
                    <PlayerInner player={player} flag={''} inPairGroup />
                    {partner}
                </li>
            );
        }
    }
}

export default PlayersPairs;
